/* eslint-disable import/prefer-default-export */
/* istanbul ignore file */
import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

export function fetchLogs() {
  return from(axios.post('/administration/audits/log/get')).pipe(map(({ data }) => data));
}

export function logEvent(event) {
  return from(axios.post('/infrastructure/menu/CreateUserTrackingAudits', event)).pipe(
    map(({ data }) => ({
      ...data,
      data: data.success ? data.data : {}
    }))
  );
}

export function getAuditLogUsersList() {
  return from(axios.post('/administration/audits/log/users/get')).pipe(map(({ data }) => data));
}
